import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiurl } from "../Constants";

export const fetchCategory = createAsyncThunk(
  "category/fetchCategory",
  async () => {
    const response = await axios.get(apiurl + "category");
    return response.data.data;
  }
);

const initialState = {
    category:[],
    status:'idle',
    error:null,
    loading:false,
}

const fetchCategoryslice = createSlice({
    name:'category',
    initialState,
    reducers:{},
    extraReducers:(builder)=>{
        builder.addCase(fetchCategory.pending, (state)=>{
            state.loading = true;
            state.status = "loading";
        }).addCase(fetchCategory.fulfilled, (state,action)=>{
            state.loading = false;
            state.status = "succeded";
            state.category = action.payload;
        }).addCase(fetchCategory.rejected, (state,action)=>{
            state.loading = false;
            state.status = "rejected";
            state.error = action.error.message;
        });
    }
})

export default fetchCategoryslice.reducer;
